var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_wrap"},[_c('bsHeader',{attrs:{"title":"PDF"},on:{"backurl":function($event){return _vm.$router.back()}}}),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.pdfLink,"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }